module.exports = __webpack_public_path__ + "static/media/image_73.e1baac78.png";